// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 918 ? "4596ecfc" : chunkId) + "." + {"123":"cc8ed755a2207810","180":"427484e46f52e145","233":"7134ccde5fa849b1","248":"cddcdfc6d79a55c7","806":"b6db9a5bfcb10d4c","918":"8204d1d2ac9eafb9","988":"6c2a0985a32c0e6a"}[chunkId] + ".js";
};